module.exports = __webpack_public_path__ + "media/frontend/assets/how-to-play/board-screenshot-bf26b66541f58b20613ff5ff7c4443ad.png";